/**
     * 比较版本号
     * @param  {string} source 比较源
     * @param  {string} target 比较目标
     * @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
     */
export default function compareAppVersion(source: any, target: any) {
  const sourceArr = source.split('.');
  const targetArr = target.split('.');
  for (let i = 0; i < sourceArr.length; i++) {
    if (sourceArr[i] !== targetArr[i]) {
      sourceArr[i] = isNaN(sourceArr[i]) ? 0 : sourceArr[i];
      targetArr[i] = isNaN(targetArr[i]) ? 0 : targetArr[i];
      return sourceArr[i] - targetArr[i];
    }
  }
  return 0;
}
